(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jd-card-second-image"] && !Shopify.designMode) return;
  try {
    (() => {
    const ready = new WeakSet();
    function init(root) {
      const frames = root.matches?.('[data-jd-card-photo]') ? [root] : Array.from(root.querySelectorAll?.('[data-jd-card-photo]') || []);
      frames.forEach(frame => {
        const second = frame.querySelector('.jd-card-photo__second');
        if (!second || ready.has(frame)) return;
        ready.add(frame);
        const link = frame.closest('a');
        const host = link ? link.parentElement : frame.closest('.card__inner') || frame.parentElement;
        if (getComputedStyle(host).position === 'static') host.classList.add('jd-card-photo-host');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'jd-card-photo-toggle';
        button.setAttribute('aria-label', second.dataset.secondLabel);
        button.setAttribute('aria-pressed', 'false');
        button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="7" y="7" width="14" height="14" rx="2"/><path d="M17 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h2M8 17l4-4 3 3 2-2 3 3"/><circle cx="16" cy="11" r="1"/></svg><span aria-hidden="true">1/2</span>';
        host.appendChild(button);
        const position = () => {
          const f = frame.getBoundingClientRect(), h = host.getBoundingClientRect();
          button.style.left = `${f.right - h.left - host.clientLeft - 52}px`;
          button.style.top = `${f.bottom - h.top - host.clientTop - 52}px`;
        };
        const observer = new ResizeObserver(position);
        observer.observe(frame);
        observer.observe(host);
        position();
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          const selected = frame.classList.toggle('is-secondary');
          button.setAttribute('aria-pressed', String(selected));
          button.setAttribute('aria-label', selected ? second.dataset.firstLabel : second.dataset.secondLabel);
          button.querySelector('span').textContent = selected ? '2/2' : '1/2';
        });
        const failed = () => {
          frame.classList.remove('is-secondary');
          second.remove();
          button.remove();
          observer.disconnect();
        };
        second.addEventListener('error', failed, {once:true});
        if (second.complete && !second.naturalWidth) failed();
      });
    }
    const start = () => {
      init(document);
      new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1) init(node);
      }))).observe(document.body, {childList:true,subtree:true});
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jd-qikify-gifts"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.querySelector('[data-jd-qikify-gifts]');
    if (!config) return;

    const sourceLabels = new WeakMap();
    const displayLabels = new WeakMap();

    const sentenceCase = (text) => {
      if (text !== text.toUpperCase()) return text;
      const properNames = {
        'mid-autumn': 'Mid-Autumn',
        'diwali': 'Diwali',
        'indian': 'Indian',
        'celebrate together': 'Celebrate Together'
      };
      return text.toLowerCase()
        .replace(/^./, (letter) => letter.toUpperCase())
        .replace(/\b(mid-autumn|diwali|indian|celebrate together)\b/g, (name) => properNames[name]);
    };

    const updateLabels = (root) => {
      root.querySelectorAll('.qsc2-product-item__discount-wrapper').forEach((label) => {
        const title = label.querySelector('.qsc2-product-item__discount-title');
        const item = label.closest('.qsc2-product-item');
        if (!title || !item) return;

        const current = title.textContent.trim();
        if (current !== displayLabels.get(title)) sourceLabels.set(title, current);
        const source = sourceLabels.get(title) || current;
        let heading = label.querySelector('.jd-qikify-gift-heading');

        if (!/^free\s/i.test(source)) {
          if (label.classList.contains('jd-qikify-gift-label')) label.classList.remove('jd-qikify-gift-label');
          heading?.remove();
          return;
        }

        if (!label.classList.contains('jd-qikify-gift-label')) label.classList.add('jd-qikify-gift-label');
        if (!heading) {
          heading = document.createElement('span');
          heading.className = 'jd-qikify-gift-heading';
          label.insertBefore(heading, title);
        }

        const headingText = item.classList.contains('qsc2-product-item--free')
          ? config.dataset.giftHeading
          : config.dataset.qualifyingHeading;
        if (heading.textContent !== headingText) heading.textContent = headingText;

        const display = document.documentElement.lang.toLowerCase().startsWith('en')
          ? sentenceCase(source)
          : source;
        displayLabels.set(title, display);
        if (title.textContent !== display) title.textContent = display;
      });
    };

    const connect = (root) => {
      let scheduled = false;
      const observer = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          updateLabels(root);
        });
      });
      observer.observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class']
      });
      updateLabels(root);
    };

    const root = document.getElementById('qikify-stickycart-v2-app');
    if (root) {
      connect(root);
    } else {
      const startup = new MutationObserver(() => {
        const app = document.getElementById('qikify-stickycart-v2-app');
        if (!app) return;
        startup.disconnect();
        connect(app);
      });
      startup.observe(document.body, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
